import { z } from "zod";
import { fwfColumnMappingSchema } from "@erp/shared-types";

// The per-field fixed-width mapping shape is the canonical one in
// `@erp/shared-types` (also used by DataSourceLink parse config). Re-exported
// here so existing step/handler imports stay stable.
export { fwfColumnMappingSchema };
export type { FwfColumnMapping } from "@erp/shared-types";

export const fwfOptionsSchema = z.object({
  columnMappings: z.array(fwfColumnMappingSchema),
});

export type FwfOptions = z.infer<typeof fwfOptionsSchema>;
